"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

function shallowCopyObject(object) {
  var copy = {};
  Object.keys(object).forEach(function (key) {
    copy[key] = object[key];
  });
  return copy;
}

exports.shallowCopyObject = shallowCopyObject;